const JUSH_CITIES = ['kraków', 'wrocław', 'warszawa'];

const CITY_COORDINATES = {
  warszawa: { lat: 52.2297, lng: 21.0122, radius: 50 },
  kraków: { lat: 50.0647, lng: 19.9450, radius: 40 },
  wrocław: { lat: 51.1079, lng: 17.0385, radius: 40 }
};

function calculateDistance(lat1, lon1, lat2, lon2) {
  const R = 6371;
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLon = (lon2 - lon1) * Math.PI / 180;
  const a = 
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
}

function isInTargetCity(latitude, longitude) {
  for (const city in CITY_COORDINATES) {
    const { lat, lng, radius } = CITY_COORDINATES[city];
    const distance = calculateDistance(latitude, longitude, lat, lng);
    if (distance <= radius) {
      return true;
    }
  }
  return false;
}

async function getUserCity(latitude, longitude) {
  try {
    const response = await fetch(
      `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}&accept-language=pl`
    );
    const data = await response.json();
    
    if (data.address) {
      const city = data.address.city || data.address.town || data.address.village || '';
      return city.toLowerCase();
    }
  } catch (error) {
  }
  
  return isInTargetCity(latitude, longitude) ? 'target_city' : 'other';
}

function showBannerVariant(variant) {
  const jushBanner = document.querySelector('[data-geo-variant="jush"]');
  const allegroBanner = document.querySelector('[data-geo-variant="allegro"]');
  
  if (!jushBanner || !allegroBanner) {
    return;
  }
  
  if (variant === 'jush') {
    jushBanner.style.display = 'block';
    allegroBanner.style.display = 'none';
  } else {
    jushBanner.style.display = 'none';
    allegroBanner.style.display = 'block';
  }
}

function isTargetCity(cityName) {
  if (!cityName || cityName === 'target_city') return false;
  const normalizedCity = cityName.toLowerCase().trim();
  return JUSH_CITIES.some(city => normalizedCity.includes(city));
}

function initGeoTargeting() {
  const jushBanner = document.querySelector('[data-geo-variant="jush"]');
  const allegroBanner = document.querySelector('[data-geo-variant="allegro"]');
  
  if (!jushBanner || !allegroBanner) {
    return;
  }
  
  if (!navigator.geolocation) {
    return;
  }
  
  navigator.geolocation.getCurrentPosition(
    async (position) => {
      const { latitude, longitude } = position.coords;
      
      const city = await getUserCity(latitude, longitude);
      
      if (isTargetCity(city)) {
        showBannerVariant('jush');
      } else if (isInTargetCity(latitude, longitude)) {
        showBannerVariant('jush');
      } else {
        showBannerVariant('allegro');
      }
    },
    (error) => {
      
    },
    {
      enableHighAccuracy: false,
      timeout: 10000,
      maximumAge: 300000
    }
  );
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initGeoTargeting);
} else {
  initGeoTargeting();
}

export { initGeoTargeting };
